
import React, { useEffect } from 'react';
import ChildCard from './ChildCard';
import { Child } from '@/types/child';
import { Skeleton } from '@/components/ui/skeleton';
import { logger } from '@/utils/logger';

interface ChildGridProps {
  children: Child[];
  isLoading?: boolean;
}

const ChildGrid: React.FC<ChildGridProps> = ({ children, isLoading = false }) => {
  useEffect(() => {
    logger.log("ChildGrid rendering with children:", children, "isLoading:", isLoading);
  }, [children, isLoading]);
  
  if (isLoading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {Array(3).fill(0).map((_, index) => (
          <div key={index} className="h-64 border rounded-lg overflow-hidden">
            <Skeleton className="h-full w-full" />
          </div>
        ))}
      </div>
    );
  }
  
  if (!children || children.length === 0) {
    return (
      <div className="text-center py-8">
        <p className="text-muted-foreground">No children found. Add your first child to get started!</p>
      </div>
    );
  }
  
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {children.map((child) => (
        <ChildCard key={child.id} child={child} />
      ))}
    </div>
  );
};

export default ChildGrid;
